import { LineChart } from 'lucide-react'
import { totalChanges, type WorkbenchUpdateSummary } from '../workbenchUpdate'
import WorkbenchChangesRow from './WorkbenchChangesRow'

interface BotMessageWorkbenchProps {
  summary: WorkbenchUpdateSummary
}

/**
 * A workbench update the user sent, in the chat history: its own card rather
 * than a chip on a message, because it IS the message — Send to AI sends it on
 * its own. Right-aligned like the user's other turns; styled after the answered
 * clarifying-questions card.
 *
 * What the user typed to go with it sits under the Changes line, where the box
 * sat under it in the composer.
 */
export default function BotMessageWorkbench({ summary }: BotMessageWorkbenchProps) {
  const chartLabel = summary.label.replace(/ chart$/, '')
  return (
    <div className="flex justify-end">
      <div
        className="w-full max-w-[85%] rounded-lg border border-border bg-card p-3 flex flex-col gap-2.5"
        data-testid="workbench-update-card"
      >
        <div className="flex items-center gap-2 min-w-0">
          <LineChart size={14} strokeWidth={2} aria-hidden className="shrink-0 text-warning" />
          <span className="text-label text-foreground">{summary.first ? 'Chart sent to AI' : 'Workbench changed'}</span>
          {chartLabel && <span className="ml-auto text-caption text-muted-foreground truncate">{chartLabel}</span>}
        </div>
        {totalChanges(summary.counts) > 0 && <WorkbenchChangesRow summary={summary} sent />}
        {summary.message && (
          <p className="text-body text-foreground whitespace-pre-wrap break-words" data-testid="workbench-update-message">
            {summary.message}
          </p>
        )}
      </div>
    </div>
  )
}
